import { useEffect, useRef, useState } from "react";
import { FaChevronRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./legal.css";

export default function CustomerTerm() {
    // show/hide breadcrumb while user scrolls
    const [showBreadcrumb, setShowBreadcrumb] = useState(true);
    const scrollTimeoutRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            // hide immediately
            setShowBreadcrumb(false);

            // clear previous timer
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }

            // show again after user stops scrolling for 600ms
            scrollTimeoutRef.current = setTimeout(() => {
                setShowBreadcrumb(true);
            }, 600);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    };

    return (
        <div className="legal-container">
            <div className={`legal-breadcrumb ${showBreadcrumb ? "visible" : "hidden"}`}>
                <Link to="/legal" className="legal-breadcrumb-link block text-xs mb-1" onClick={scrollToTop}>
                    Legal
                </Link>
                <FaChevronRight className="legal-breadcrumb-icon" />
                <Link to="/legal/privacy-policy" className="legal-breadcrumb-link block text-xs mb-1" onClick={scrollToTop}>
                    Privacy Policy
                </Link>
                <FaChevronRight className="legal-breadcrumb-icon" />
                <span className="legal-breadcrumb-current block text-xs mb-1">Customer Term</span>
                <FaChevronRight className="legal-breadcrumb-icon" />
                <Link to="/legal/service-provider-term" className="legal-breadcrumb-link block text-xs mb-1" onClick={scrollToTop}>
                    Service Provider Term
                </Link>
            </div>
            <div className="legal-breadcrumb-content">
                <h1 className="legal-title">Terms of Use for Customers</h1>

                <p className="legal-description">
                    Customer Terms
                    <br />
                    Last updated: January 1, 2026
                </p>


                <div className="legal-content">
                    <p> Welcome to FixerFind. By using our website, mobile app, or services, you
                        agree to these Terms of Service. Please read them carefully.</p>
                    <h2 className="legal-section-title">
                        Interpretation and Definitions
                    </h2>
                    <h2 className="legal-section-title">
                        Interpretation
                    </h2>
                    <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.</p>

                    <h2 className="legal-section-title">Definitions</h2>
                    <p>For the purposes of these Terms and Conditions:</p>

                    <ul className="legal-list">

                        <li>

                            <strong className="legal-subtitle">Application</strong> means the software program provided by the Company downloaded by You on any electronic device, named FixerFind

                        </li>

                        <li>

                            <strong className="legal-subtitle">Application Store</strong> means the digital distribution service operated and developed by Apple Inc. (Apple App Store) or Google Inc. (Google Play Store) in which the Application has been downloaded.

                        </li>

                        <li>

                            <strong className="legal-subtitle">Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where &quot;control&quot; means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.

                        </li>

                        <li>

                            <strong className="legal-subtitle">Country</strong> refers to:  Nigeria, and/or of country of use of FixerFind Application.

                        </li>

                        <li>

                            <strong className="legal-subtitle">Company</strong> (referred to as either &quot; the Company&quot;, &quot; We&quot;, &quot; Us&quot; or &quot; Our&quot; in this Agreement) refers to FixerFind, FCT Abuja, Nigeria..

                        </li>

                        <li>

                            <strong className="legal-subtitle">Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.

                        </li>

                        <li>

                            <strong className="legal-subtitle">Service</strong> refers to the Application or the Website or both.

                        </li>

                        <li>

                            <strong className="legal-subtitle">Terms and Conditions</strong> (also referred as &quot;Terms&quot;) mean these Terms and Conditions that form the entire agreement between You and the Company regarding the use of the Service.

                        </li>

                        <li>

                            <strong className="legal-subtitle">Third-party Social Media Service</strong> means any services or content (including data, hellormation, products or services) provided by a third-party that may be displayed, included or made available by the Service.

                        </li>

                        <li>

                            <strong className="legal-subtitle">Website</strong> refers to FixerFind, accessible from <a href="www.fixerfind.com" rel="noopener noreferrer" target="_blank">www.fixerfind.com</a>

                        </li>

                        <li>

                            <strong className="legal-subtitle">You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.

                        </li>

                        <li>

                            <strong className="legal-subtitle">Service Provider</strong> means the individual provideing You his/her service through FixerFind.

                        </li>

                    </ul>

                    <h2 className="legal-section-title">
                        Acknowledgment
                    </h2>
                    <p>These are the Terms and Conditions governing the use of this Service and the agreement that operates between You and the Company. These Terms and Conditions set out the rights and obligations of all users regarding the use of the Service.</p>

                    <p>Your access to and use of the Service is conditioned on Your acceptance of and compliance with these Terms and Conditions. These Terms and Conditions apply to all visitors, users and others who access or use the Service.</p>

                    <p>By accessing or using the Service You agree to be bound by these Terms and Conditions. If You disagree with any part of these Terms and Conditions then You may not access the Service.</p>

                    <p>You represent that you are over the age of 13. The Company does not permit those under 13 to use the Service.</p>

                    <p>Your access to and use of the Service is also conditioned on Your acceptance of and compliance with the Privacy Policy of the Company. Our Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your personal hellormation when You use the Application or the Website and tells You about Your privacy rights and how the law protects You. Please read <Link to={"/legal/privacy-policy"} className="legal-link-pages" onClick={scrollToTop}>Our Privacy Policy</Link> carefully before using  <a href={"https://onelink.to/yyvjtr"} target="_blank" rel="noopener noreferrer" className="legal-link-pages" onClick={scrollToTop}>Our Service.</a></p>

                    <h2 className="legal-section-title">Our Easy Follow Suit Rules</h2>

                    <p>By entering, accessing or using the Service you acknowledge that you have read, understood and agreed with these terms of use with FixerFind and <Link
                        to={"/legal/privacy-policy"} className="legal-link-pages" onClick={scrollToTop}>FixerFind Privacy Policy</Link>, and you agree to be bound by them and to comply with all applicable laws and regulations regarding your use of the Service.</p>
                    <p> FixerFind reserves the right to fulfill its obligations to you under these Terms itself or through one of
                        its Affiliates. <h3 className="legal-subtitle" id="RED">IF YOU DO NOT AGREE TO THESE TERMS, PLEASE DO NOT ACCESS OR USE FIXERFIND SERVICE</h3>.
                    </p>
                    <p> These Terms are a binding and enforceable legal contract between you and FixerFind, so please read them
                        carefully.
                    </p>

                    <p>
                        <strong> Note:</strong> FixerFind will Not be responsible for any issues or problems which is Not likely to occur between you the "Customer" and the "Service Provider".
                    </p>

                    <h2 className="legal-section-title">Transactions And Rules That Follows</h2>

                    <p>The Service provides you an intermediate connection with You and the available Service Provider of your selected service, stating that all arrangemnts, procedures, price negotiations and payments are settled and agreed between You and the Service Provider.</p>

                    <p>The Service provides you the availability to pay your due agreed payments to the Service Provider through us, by conecting you with a third party, finance company with a transfer fee added on transaction.</p>

                    <h2 className="legal-section-title" >Links to Other Websites</h2>

                    <p>Our Service may contain links to third-party web sites or services that are not owned or controlled by the Company.</p>

                    <p>The Company has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that the Company shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods or services available on or through any such web sites or services.</p>

                    <p>We strongly advise You to read the terms and conditions and privacy policies of any third-party web sites or services that You visit.</p>
                    <h2 className="legal-section-title" >Safety Caution!</h2>

                    <p>FixerFind is not responsible for what goes on after connecting you and the hired Service Provider. </p>

                    <p> Be aware of whose services you hire, for official services ensure to request for valid Certificate of Right to perfom service. </p>

                    <p> Verified Service Provider details are more secured & trusted by FixerFind. </p>

                    <p> Do Not Call a Service into your home while alone, share details with a friend before arrival.</p>

                    <p> Make immediate reports to Legal Authorities, if any issue arises. </p>

                    <h2 className="legal-section-title">
                        Referral Program Rules
                    </h2>

                    <p>
                        By participating in the FixerFind Referral Program, you agree to fully comply with
                        the terms, conditions, and rules outlined below. FixerFind reserves the right to
                        modify, suspend, or terminate this program at any time without prior notice.
                    </p>

                    <h4 className="legal-subtitle">Referral Reward Eligibility</h4>

                    <p>
                        Participants are eligible to earn a referral reward of <strong>$100.00
                            (approximately ₦160,000.00)</strong> upon successfully referring
                        <strong> one hundred (100)</strong> friends who meet all qualification requirements
                        stated herein.
                    </p>

                    <strong>QUALIFICATION REQUIREMENTS</strong>

                    <ul className="legal-list">
                        <li>
                            Each referred individual must successfully register for a FixerFind Premium
                            account using a valid referral.
                        </li>
                        {/* <li>
                            Each referred individual must complete and maintain an active
                            <strong> twelve (12) consecutive months</strong> of a FixerFind Premium
                            subscription.
                        </li> */}
                        <li>
                            Each referred individual must complete a total of
                            <strong> twelve (12) months</strong> of a FixerFind Premium
                            subscription.
                        </li>
                        <li>
                            Only referrals that successfully complete the full 12-month premium plan
                            will be counted toward the referral total.
                        </li>
                        <li>
                            Each referred user may only be counted once and cannot be used by multiple
                            referrers.
                        </li>
                        <li>
                            Fraudulent, duplicate, or incomplete referrals will be disqualified at the
                            sole discretion of FixerFind.
                        </li>
                    </ul>

                    <h4 className="legal-subtitle">Reward Issuance</h4>

                    <ul className="legal-list">
                        <li>
                            The referral reward becomes payable only after all 100 referred users have
                            successfully completed their 12-month premium plans.
                        </li>
                        <li>
                            Rewards will be issued via the payment method approved by FixerFind at the
                            time of payout.
                        </li>
                        <li>
                            FixerFind is not responsible for delays caused by incorrect or incomplete
                            payment information provided by the participant.
                        </li>
                    </ul>

                    <p>
                        For referral verification or inquiries, participants may contact FixerFind via
                        email at <strong>hello@fixerfind.com</strong>.
                    </p>

                    <h2 className="legal-section-title" >Termination</h2>

                    <p>We may terminate or suspend Your access immediately, without prior notice or liability, for any reason whatsoever, including without limitation if You breach these Terms and Conditions.</p>

                    <p>Upon termination, Your right to use the Service will cease immediately.</p>
                    <h2 className="legal-section-title" >Limitation of Liability</h2>

                    <p>Notwithstanding any damages that You might incur, the entire liability of the Company and any of its suppliers under any provision of this Terms and Your exclusive remedy for all of the foregoing shall be limited to the amount actually paid by You through the Service or 100 USD if You haven't purchased anything through the Service.</p>

                    <p>To the maximum extent permitted by applicable law, in no event shall the Company or its suppliers be liable for any special, incidental, indirect, or consequential damages whatsoever (including, but not limited to, damages for loss of profits, loss of data or other hellormation, for business interruption, for personal injury, loss of privacy arising out of or in any way related to the use of or inability to use the Service, third-party software and/or third-party hardware used with the Service, or otherwise in connection with any provision of this Terms), even if the Company or any supplier has been advised of the possibility of such damages and even if the remedy fails of its essential purpose.</p>

                    <p>Some states do not allow the exclusion of implied warranties or limitation of liability for incidental or consequential damages, which means that some of the above limitations may not apply. In these states, each party's liability will be limited to the greatest extent permitted by law.</p>
                    <h2 className="legal-section-title" >
                        &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; Disclaimer
                    </h2>
                    <p>The Service is provided to You &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; and with all faults and defects without warranty of any kind. To the maximum extent permitted under applicable law, the Company, on its own behalf and on behalf of its Affiliates and its and their respective licensors and service providers, expressly disclaims all warranties, whether express, implied, statutory or otherwise, with respect to the Service, including all implied warranties of merchantability, fitness for a particular purpose, title and non-infringement, and warranties that may arise out of course of dealing, course of performance, usage or trade practice. Without limitation to the foregoing, the Company provides no warranty or undertaking, and makes no representation of any kind that the Service will meet Your requirements, achieve any intended results, be compatible or work with any other software, applications, systems or services, operate without interruption, meet any performance or reliability standards or be error free or that any errors or defects can or will be corrected.</p>

                    <p>Without limiting the foregoing, neither the Company nor any of the company's provider makes any representation or warranty of any kind, express or implied: (i) as to the operation or availability of the Service, or the hellormation, content, and materials or products included thereon; (ii) that the Service will be uninterrupted or error-free; (iii) as to the accuracy, reliability, or currency of any hellormation or content provided through the Service; or (iv) that the Service, its servers, the content, or e-mails sent from or on behalf of the Company are free of viruses, scripts, trojan horses, worms, malware, timebombs or other harmful components.</p>

                    <p>Some jurisdictions do not allow the exclusion of certain types of warranties or limitations on applicable statutory rights of a consumer, so some or all of the above exclusions and limitations may not apply to You. But in such a case the exclusions and limitations set forth in this section shall be applied to the greatest extent enforceable under applicable law.</p>

                    <h2 className="legal-section-title" >Governing Law</h2>
                    <p>The laws of the Country, excluding its conflicts of law rules, shall govern this Terms and Your use of the Service. Your use of the Application may also be subject to other local, state, national, or international laws.</p>

                    <h2 className="legal-section-title" >Disputes Resolution</h2>

                    <p>If You have any concern or dispute about the Service, You agree to first try to resolve the dispute hellormally by contacting the Company.</p>

                    <h2 className="legal-section-title" >For European Union (EU) Users</h2>
                    <p>If You are a European Union consumer, you will benefit from any mandatory provisions of the law of the country in which you are resident in.</p>
                    <h2 className="legal-section-title" >United States Legal Compliance</h2>
                    <p>You represent and warrant that (i) You are not located in a country that is subject to the United States government embargo, or that has been designated by the United States government as a &quot;terrorist supporting&quot; country, and (ii) You are not listed on any United States government list of prohibited or restricted parties.</p>

                    <h2 className="legal-section-title" >Severability and Waiver</h2>
                    <h4 className="legal-subtitle" >Severability</h4>
                    <p>If any provision of these Terms is held to be unenforceable or invalid, such provision will be changed and interpreted to accomplish the objectives of such provision to the greatest extent possible under applicable law and the remaining provisions will continue in full force and effect.</p>

                    <h4 className="legal-subtitle" >Waiver</h4>
                    <p>Except as provided herein, the failure to exercise a right or to require performance of an obligation under these Terms shall not effect a party's ability to exercise such right or require such performance at any time thereafter nor shall the waiver of a breach constitute a waiver of any subsequent breach.</p>

                    <h2 className="legal-section-title" >Translation Interpretation</h2>

                    <p>These Terms and Conditions may have been translated if We have made them available to You on our Service.

                        You agree that the original English text shall prevail in the case of a dispute.</p>

                    <h2 className="legal-section-title" >Changes to These Terms and Conditions</h2>

                    <p>We reserve the right, at Our sole discretion, to modify or replace these Terms at any time. If a revision is material We will make reasonable efforts to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at Our sole discretion.</p>

                    <p>By continuing to access or use Our Service after those revisions become effective, You agree to be bound by the revised terms. If You do not agree to the new terms, in whole or in part, please stop using the website and the Service.</p>

                    <h2 className="legal-section-title">Contact Us</h2>
                    <p>
                        If you have any questions about this Privacy Policy, You can contact
                        us at:{" "}
                        <a
                            href="mailto:hello@fixerfind.com"
                            className="legal-link-pages"
                        >
                            hello@fixerfind.com
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
}
